module.exports = __webpack_public_path__ + "static/media/biruxPlata112.91bb85c5.png";